import styled from "@emotion/styled";

import { commonColors } from "application/theme";

export const Container = styled("div")`
  height: 100%;
  padding: 12px 16px;
  background: ${commonColors.grey100};
`;

export const HeaderStyled = styled("header")`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  button {
    all: unset;
    cursor: pointer;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-left: 12px;
      /* font */
      font-size: 14px;
      font-weight: 400;
      line-height: 130%;
      letter-spacing: 0.07px;
      color: ${commonColors.grey900};
    }
  }
`;

export const IconContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${commonColors.white400};
  border: 1px solid ${commonColors.white};

  svg {
    width: 24px;
    height: 24px;

    path {
      fill: ${commonColors.grey900};
    }
  }
`;

export const Title = styled("h1")`
  /* font */
  font-size: 24px;
  font-weight: 500;
  line-height: 130%;
  color: ${commonColors.grey900};
  background: ${commonColors.lemonPie};
`;

export const Card = styled("div")`
  padding: 16px;
  margin-top: 32px;
  border-radius: 18px;
  background: ${commonColors.white};
  box-shadow: 0 4px 10px 0 rgba(26, 40, 104, 0.1);

  .divider {
    height: 1px;
    margin: 12px 0;
    background: ${commonColors.grey200};
  }

  svg {
    width: 28px;
    height: 28px;
    margin-bottom: 8px;
  }
`;

export const QuestionText = styled("p")`
  /* font */
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.08px;
  color: ${commonColors.grey900};
`;

export const PendingText = styled("p")`
  /* font */
  font-size: 14px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.07px;
  color: ${commonColors.grey500};
`;

export const AnswerDateText = styled("p")`
  margin-top: 8px;
  /* font */
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
  text-align: right;
  letter-spacing: 0.06px;
  color: ${commonColors.grey500};
`;
